import { IconButton } from '@material-ui/core';
import { Visibility as VisibilityIcon } from '@material-ui/icons';
import { getAchievements } from '@webapps/business';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { getFileURLPDF } from '@webapps/utils';
import ModalFullScreenWithoutAction from 'components/ModalFullScreenWithoutAction/ModalFullScreenWithoutAction';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const Achievement = ({ info = {} }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const userid = info?.id;

  const { data: achievements = [] } = useQuery(getAchievements, {
    key: ['achievements', userid],
    variables: { id: userid },
    enabled: typeof userid !== 'undefined',
  });

  const [viewAchievement, setViewAchievement] = useState(false);
  const [path, setPath] = useState('');

  const goToPath = (url) => {
    // eslint-disable-next-line no-unused-expressions
    url.includes('http')
      ? window.open(url, '_blank', 'noopener,noreferrer')
      : window.open(`http://${url}`, '_blank', 'noopener,noreferrer');
  };

  const handleOpenViewAchievement = (link, type) => {
    setPath('');
    getFileURLPDF(link, setPath);
    if (type === 'link' || type === 'lien') goToPath(link);
    else setViewAchievement(true);
  };
  const handleCloseViewAchievement = () => {
    setViewAchievement(false);
  };

  return (
    <div className={cx(classes.container)}>
      <div className={classes.editContainer}>
        <div className={cx(classes.title, global.title)}>
          <FormattedMessage id="student.profil.realisation.title" />
        </div>
      </div>
      {!achievements?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableHeadRow>
                <TableHeadCell
                  style={{
                    width: '33%',
                    padding: spacing(1, 0),
                    textTransform: 'none',
                  }}
                >
                  <FormattedMessage id="student.profil.realisation.table.nom" />
                </TableHeadCell>
                <TableHeadCell
                  style={{
                    width: '33%',
                    padding: spacing(1, 0),
                    textTransform: 'none',
                  }}
                >
                  <FormattedMessage id="student.profil.realisation.table.format" />
                </TableHeadCell>
                <TableHeadCell style={{ width: '33%' }} />
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {achievements?.map(({ id, label, path: pathFile, type }) => (
                <TableRow key={id}>
                  <TableCell
                    style={{
                      padding: spacing(1, 0),
                      color: '#152652',
                      border: 'none',
                    }}
                  >
                    {label}
                  </TableCell>
                  <TableCell
                    style={{
                      padding: spacing(1, 0),
                      color: '#152652',
                      border: 'none',
                    }}
                  >
                    {type === 'link' ? 'Lien' : 'Fichier'}
                  </TableCell>
                  <TableCell
                    style={{
                      padding: spacing(1, 0),
                      border: 'none',
                    }}
                  >
                    <IconButton size="small">
                      <VisibilityIcon
                        color="primary"
                        fontSize="small"
                        onClick={() =>
                          handleOpenViewAchievement(pathFile, type)
                        }
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <ModalFullScreenWithoutAction
        onCancel={handleCloseViewAchievement}
        open={viewAchievement}
        title="Réalisations"
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={path}
          title="Fichier"
        />
      </ModalFullScreenWithoutAction>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    borderLeft: '3px solid #0060F9',
    paddingLeft: spacing(1),
  },
});

Achievement.propTypes = {
  info: PropTypes.object,
};

export default Achievement;
